import { render, staticRenderFns } from "./TmBalance.vue?vue&type=template&id=4c74847e&scoped=true&"
import script from "./TmBalance.vue?vue&type=script&lang=js&"
export * from "./TmBalance.vue?vue&type=script&lang=js&"
import style0 from "./TmBalance.vue?vue&type=style&index=0&id=4c74847e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c74847e",
  null
  
)

export default component.exports